import { create } from '@bufbuild/protobuf';

import * as pbs from '@/grpc-gen/html_template_service_pb';
import { strcmp } from '@/services/common';
import * as pbm from '@/grpc-gen/html_template_pb';

export default class HtmlTemplate {
  id: number = 0;

  name: string = '';

  design?: string;

  html?: string;

  preview?: string;

  plaintext?: string;

  created: Date = new Date();

  updated: Date = new Date();

  isDeleted?: boolean;

  isDefault: boolean = false;

  get value() { return this.id; }

  get text() { return this.name; }

  static fromGrpcResponse(r: pbs.HtmlTemplateListResponse): HtmlTemplate {
    return HtmlTemplate.fromGrpcModel(r.htmlTemplate);
  }

  static compare(o1: HtmlTemplate, o2: HtmlTemplate): number {
    let res = (o1.isDefault ? 1 : -1) - (o2.isDefault ? 1 : -1);
    if (res !== 0) return -res;

    res = strcmp(o1.name ?? '', o2.name ?? '');
    if (res !== 0) return res;

    return o1.id - o2.id;
  }

  constructor(o?: { id?: number, name: string, design?: string, html?: string, plaintext?: string, preview?: string }) {
    this.id = o?.id ?? 0;
    this.name = o?.name ?? '';
    this.design = o?.design;
    this.html = o?.html;
    this.preview = o?.preview;
    this.plaintext = o?.plaintext;
  }

  static fromGrpcModel(o?: pbm.HtmlTemplate): HtmlTemplate {
    const e = new HtmlTemplate();

    e.id = Number(o?.id ?? 0);
    e.name = o?.name || 'N/A';
    e.design = o?.design || undefined;
    // e.html = o?.getHtml(); - no html from grpc
    // e.plaintext = o?.getPlaintext(); - no plaintext from grpc
    e.preview = o?.preview || undefined;
    e.created = o?.dtCreate ? new Date(Number(o.dtCreate) * 1000) : new Date();
    e.updated = o?.dtUpdate ? new Date(Number(o.dtUpdate) * 1000) : new Date();
    e.isDeleted = o?.isDeleted || undefined;
    e.isDefault = o?.isDefault ?? false;

    return e;
  }

  toGrpcModel(): pbm.HtmlTemplate {
    return create(pbm.HtmlTemplateSchema, {
      id: BigInt(this.id),
      name: this.name ?? '',
      design: this.design ?? '',
      html: this.html ?? '',
      plaintext: this.plaintext ?? '',
      preview: '',
      dtCreate: 0n,
      dtUpdate: 0n,
      isDeleted: this.isDeleted ?? false,
      isDefault: this.isDefault ?? false,
    });
  }
}

export function areHtmlTemplatesSame(o1: HtmlTemplate, o2: HtmlTemplate): boolean {
  return o1.design === o2.design && o1.name === o2.name;
}
